<template>
  <div class="sci-view-container">
    <header class="sci-header">
      <div class="sci-header-left">
        <button class="sci-btn-back" @click="goBack">
          <i class="fas fa-arrow-left"></i>
          <span>{{ $t('gestionale') || 'Gestionale' }}</span>
        </button>
        <div class="sci-title-group">
          <h1 class="sci-title">
            <i class="fas fa-user-clock me-2 text-primary"></i>
            {{ $t('TIMBRATURE') || 'Gestione Timbrature & Presenze' }}
          </h1>
          <p class="sci-subtitle">Controllo orari di ingresso/uscita personale, QR code timbratrice e monte ore</p>
        </div>
      </div>
    </header>

    <div class="dashboard-grid">
      <!-- Panel 1: Manage Employees -->
      <div class="panel card-neumorphic">
        <h2>{{ editingDipendenteId ? 'Modifica Dipendente' : 'Aggiungi Dipendente' }}</h2>
        <form @submit.prevent="saveDipendente" class="form-grid">
          <div class="form-group">
            <label>Nome:</label>
            <input type="text" v-model="formDipendente.nome" required placeholder="Es. Mario">
          </div>
          <div class="form-group">
            <label>Cognome:</label>
            <input type="text" v-model="formDipendente.cognome" required placeholder="Es. Rossi">
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-save">{{ editingDipendenteId ? 'Salva' : 'Crea' }}</button>
            <button v-if="editingDipendenteId" type="button" @click="cancelEdit" class="btn btn-cancel">Annulla</button>
          </div>
        </form>

        <h2 style="margin-top: 30px;">Elenco Dipendenti</h2>
        <div class="employee-list" v-if="dipendenti.length">
          <div v-for="dip in dipendenti" :key="dip._id" class="employee-item">
            <div class="employee-info">
              <strong>{{ dip.nome }} {{ dip.cognome }}</strong>
              <small class="slug-text">Link: {{ getEmployeeUrl(dip) }}</small>
            </div>
            <div class="employee-actions">
              <button @click="copyLink(dip)" class="btn-icon" title="Copia Link">📋</button>
              <button @click="printQr(dip)" class="btn-icon" title="Stampa QR Code">🖨️</button>
              <button @click="editDipendente(dip)" class="btn-icon" title="Modifica">✏️</button>
              <button @click="deleteDipendente(dip._id)" class="btn-icon delete" title="Elimina">🗑️</button>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          Nessun dipendente registrato.
        </div>
      </div>

      <!-- Panel 2: Reports & Hours -->
      <div class="panel card-neumorphic">
        <h2>Registro Ore e Presenze</h2>
        <div class="filters">
          <div class="filter-group">
            <label>Periodo:</label>
            <select v-model="filterType" @change="fetchReport">
              <option value="day">Giorno</option>
              <option value="week">Settimana</option>
              <option value="month">Mese</option>
              <option value="year">Anno</option>
            </select>
          </div>
          <div class="filter-group">
            <label>Data di riferimento:</label>
            <input type="date" v-model="filterDate" @change="fetchReport">
          </div>
        </div>

        <div class="report-list" v-if="reportData.length">
          <div v-for="item in reportData" :key="item.dipendente._id" class="report-item">
            <div class="report-header">
              <span class="report-name">{{ item.dipendente.nome }} {{ item.dipendente.cognome }}</span>
              <span class="hours-badge">{{ item.totalHours }} ore</span>
            </div>
            <div class="timbrature-details" v-if="item.timbrature.length">
              <table>
                <thead>
                  <tr>
                    <th>Data/Ora</th>
                    <th>Tipo</th>
                    <th>IP</th>
                    <th>GPS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="t in item.timbrature" :key="t._id">
                    <td>{{ formatDateTime(t.timestamp) }}</td>
                    <td>
                      <span :class="['badge-status', t.tipo]">
                        {{ t.tipo === 'ingresso' ? 'Ingresso' : 'Uscita' }}
                      </span>
                    </td>
                    <td><code>{{ t.ip }}</code></td>
                    <td>
                      <span v-if="t.coords && t.coords.latitude">
                        <a :href="`https://www.google.com/maps?q=${t.coords.latitude},${t.coords.longitude}`" target="_blank" class="gps-link">
                          📍 Visualizza
                        </a>
                      </span>
                      <span v-else class="text-muted">N/D</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="no-timbrature-text">
              Nessuna timbratura registrata nel periodo.
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          Nessun dato disponibile.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'
import moment from 'moment'

export default {
  name: 'GestioneTimbrature',
  data() {
    return {
      store,
      dipendenti: [],
      formDipendente: {
        nome: '',
        cognome: ''
      },
      editingDipendenteId: null,
      filterType: 'day',
      filterDate: new Date().toISOString().split('T')[0],
      reportData: []
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Gestionale' })
    },
    getEmployeeUrl(dipendente) {
      const origin = window.location.origin;
      const isElectron = origin.startsWith('file://') || origin.startsWith('app://') || origin.includes('localhost:8080');
      
      let targetOrigin = origin;
      if (isElectron) {
        targetOrigin = 'http://localhost:8081';
      }
      return `${targetOrigin}/timbratura/${dipendente.slug}`;
    },
    getToken() {
      try {
        if (!localStorage.token) return localStorage.getItem('token') || '';
        const parsed = JSON.parse(localStorage.token);
        return typeof parsed === 'string' ? parsed : (localStorage.getItem('token') || '');
      } catch (e) {
        return localStorage.getItem('token') || '';
      }
    },
    fetchDipendenti() {
      const token = this.getToken();
      this.axios.get(this.store.path + 'timbrature/dipendenti', {
        headers: { authorization: `Bearer ${token}` }
      }).then(response => {
        this.dipendenti = response.data;
      }).catch(error => {
        console.error(error);
      });
    },
    saveDipendente() {
      const token = this.getToken();
      const headers = { authorization: `Bearer ${token}` };
      if (this.editingDipendenteId) {
        this.axios.put(this.store.path + 'timbrature/dipendenti/' + this.editingDipendenteId, this.formDipendente, { headers })
          .then(() => {
            alert("Dipendente modificato con successo");
            this.cancelEdit();
            this.fetchDipendenti();
            this.fetchReport();
          }).catch(error => {
            console.error(error);
            alert("Errore durante la modifica.");
          });
      } else {
        this.axios.post(this.store.path + 'timbrature/dipendenti', this.formDipendente, { headers })
          .then(() => {
            alert("Dipendente creato con successo");
            this.formDipendente.nome = '';
            this.formDipendente.cognome = '';
            this.fetchDipendenti();
            this.fetchReport();
          }).catch(error => {
            console.error(error);
            alert("Errore durante la creazione.");
          });
      }
    },
    editDipendente(dip) {
      this.editingDipendenteId = dip._id;
      this.formDipendente.nome = dip.nome;
      this.formDipendente.cognome = dip.cognome;
    },
    cancelEdit() {
      this.editingDipendenteId = null;
      this.formDipendente.nome = '';
      this.formDipendente.cognome = '';
    },
    deleteDipendente(id) {
      if (confirm("Sei sicuro di voler eliminare questo dipendente e tutte le sue timbrature?")) {
        const token = this.getToken();
        this.axios.delete(this.store.path + 'timbrature/dipendenti/' + id, {
          headers: { authorization: `Bearer ${token}` }
        }).then(() => {
          alert("Dipendente eliminato");
          this.fetchDipendenti();
          this.fetchReport();
        }).catch(error => {
          console.error(error);
          alert("Errore durante l'eliminazione.");
        });
      }
    },
    copyLink(dip) {
      const url = this.getEmployeeUrl(dip);
      navigator.clipboard.writeText(url)
        .then(() => alert("Link copiato negli appunti!"))
        .catch(() => alert("Impossibile copiare il link. Link: " + url));
    },
    printQr(dipendente) {
      const url = this.getEmployeeUrl(dipendente);
      const printWindow = window.open('', '_blank');
      const htmlContent = [
        '<' + 'html>',
        '<' + 'head>',
        '<' + 'title>Stampa QR Code - ' + dipendente.nome + ' ' + dipendente.cognome + '<' + '/title>',
        '<' + 'style>',
        'body { font-family: Arial, sans-serif; text-align: center; padding: 50px; }',
        '.container { border: 2px dashed #ccc; padding: 40px; display: inline-block; border-radius: 10px; }',
        'h1 { margin-top: 0; font-size: 28px; color: #333; }',
        'h2 { font-size: 20px; color: #666; margin-bottom: 30px; }',
        '#qrcode { margin: 20px 0; }',
        '#qrcode img { margin: 0 auto; }',
        'p { font-size: 14px; color: #888; margin-top: 30px; }',
        '<' + '/style>',
        '<' + '/head>',
        '<' + 'body>',
        '<' + 'div class="container">',
        '<' + 'h1>TIMBRATURA<' + '/h1>',
        '<' + 'h2>Scansiona per registrare Ingresso/Uscita<' + '/h2>',
        '<' + 'div id="qrcode"><' + '/div>',
        '<' + 'h3 style="font-size: 24px; margin-top: 30px;">' + dipendente.nome.toUpperCase() + ' ' + dipendente.cognome.toUpperCase() + '<' + '/h3>',
        '<' + 'p>Mymenù - Gestione Rilevazione Presenze<' + '/p>',
        '<' + '/div>',
        '<' + 'script src="https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.min.js"><' + '/script>',
        '<' + 'script>',
        'var typeNumber = 4;',
        'var errorCorrectionLevel = "L";',
        'var qr = qrcode(typeNumber, errorCorrectionLevel);',
        'qr.addData(' + JSON.stringify(url) + ');',
        'qr.make();',
        'document.getElementById("qrcode").innerHTML = qr.createImgTag(8);',
        'window.onload = function() {',
        '  window.print();',
        '  setTimeout(function() { window.close(); }, 500);',
        '};',
        '<' + '/script>',
        '<' + '/body>',
        '<' + '/html>'
      ].join('\n');
      printWindow.document.write(htmlContent);
      printWindow.document.close();
    },
    fetchReport() {
      const token = this.getToken();
      this.axios.get(this.store.path + 'timbrature/report', {
        params: {
          type: this.filterType,
          date: this.filterDate
        },
        headers: { authorization: `Bearer ${token}` }
      }).then(response => {
        this.reportData = response.data.report;
      }).catch(error => {
        console.error(error);
      });
    },
    formatDateTime(ts) {
      return moment(ts).format('DD/MM/YYYY HH:mm');
    }
  },
  beforeMount() {
    this.fetchDipendenti();
    this.fetchReport();
  }
};
</script>

<style scoped>
.sci-view-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--sci-bg, #f8fafc);
  color: var(--sci-text-main, #0f172a);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  padding-bottom: 60px;
}

/* Header */
.sci-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 28px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--sci-border, #e2e8f0);
}

.sci-header-left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.sci-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  background: #ffffff;
  border: 1px solid var(--sci-border, #e2e8f0);
  border-radius: 12px;
  color: var(--sci-text-muted, #475569);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.sci-btn-back:hover {
  background: #f1f5f9;
  color: var(--sci-text-main, #0f172a);
  border-color: #cbd5e1;
}

.sci-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.sci-subtitle {
  margin: 2px 0 0 0;
  font-size: 0.82rem;
  color: var(--sci-text-muted, #475569);
}

.dashboard-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  padding: 24px 28px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

@media (max-width: 900px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}

.card-neumorphic {
  background: #e0e0e0;
  border-radius: 20px;
  padding: 30px;
  box-shadow: -10px 10px 20px #bebebe, 10px -10px 20px #ffffff;
}

h2 {
  font-size: 1.4rem;
  margin-top: 0;
  margin-bottom: 20px;
  color: #2c3e50;
  border-bottom: 2px solid #d0d0d0;
  padding-bottom: 10px;
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: left;
}

.form-group label {
  font-size: 0.95rem;
  font-weight: bold;
  color: #555;
}

.form-group input, .form-group select, .filters select, .filters input {
  padding: 10px 15px;
  border-radius: 10px;
  border: none;
  background: #e0e0e0;
  box-shadow: inset -3px 3px 6px #bebebe, inset 3px -3px 6px #ffffff;
  font-size: 1rem;
  color: #333;
  outline: none;
  font-family: inherit;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.btn {
  padding: 10px 20px;
  border-radius: 10px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  box-shadow: -3px 3px 6px #bebebe, 3px -3px 6px #ffffff;
  transition: all 0.2s ease;
  font-family: inherit;
  font-size: 1rem;
}

.btn:active {
  box-shadow: inset -2px 2px 4px #bebebe, inset 2px -2px 4px #ffffff;
}

.btn-save {
  background-color: #3498db;
  color: white;
}

.btn-cancel {
  background-color: #95a5a6;
  color: white;
}

.employee-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
}

.employee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #e0e0e0;
  border-radius: 12px;
  box-shadow: -5px 5px 10px #bebebe, 5px -5px 10px #ffffff;
}

.employee-info {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.employee-info strong {
  font-size: 1.1rem;
  color: #2c3e50;
}

.slug-text {
  font-size: 0.8rem;
  color: #7f8c8d;
  margin-top: 4px;
  word-break: break-all;
}

.employee-actions {
  display: flex;
  gap: 5px;
}

.btn-icon {
  background: #e0e0e0;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: -3px 3px 6px #bebebe, 3px -3px 6px #ffffff;
  font-size: 1rem;
  transition: all 0.2s ease;
}

.btn-icon:active {
  box-shadow: inset -2px 2px 4px #bebebe, inset 2px -2px 4px #ffffff;
}

.btn-icon.delete {
  color: #e74c3c;
}

.empty-state {
  color: #7f8c8d;
  font-style: italic;
  padding: 20px;
}

.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 25px;
}

.filter-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: left;
}

.filter-group label {
  font-size: 0.9rem;
  font-weight: bold;
  color: #555;
}

.report-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.report-item {
  background: #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  box-shadow: -5px 5px 10px #bebebe, 5px -5px 10px #ffffff;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  border-bottom: 1px dashed #bebebe;
  padding-bottom: 10px;
}

.report-name {
  font-weight: bold;
  font-size: 1.15rem;
  color: #2c3e50;
}

.hours-badge {
  background-color: #2ecc71;
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.95rem;
  font-weight: bold;
}

.timbrature-details {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

th, td {
  padding: 8px 12px;
  font-size: 0.9rem;
}

th {
  color: #7f8c8d;
  font-weight: bold;
  border-bottom: 1px solid #d0d0d0;
}

td {
  color: #333;
}

.badge-status {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  color: white;
}

.badge-status.ingresso {
  background-color: #3498db;
}

.badge-status.uscita {
  background-color: #e67e22;
}

.gps-link {
  color: #2980b9;
  text-decoration: none;
  font-weight: bold;
}

.no-timbrature-text {
  color: #95a5a6;
  font-size: 0.9rem;
  font-style: italic;
}
</style>
